import { Cell } from 'common/src/designSystem/components/table/cell';
import { DateTimeService } from 'common/src/services/dateTimeService';
import { useService } from 'common/src/util/dependencies/dependencies';
import { LocaleFormats } from 'common/src/util/luxon';
import { DateTime } from 'luxon';
import * as React from 'react';

interface ICreatedAtCellProps {
    insertedAt: DateTime;
}

export const CreatedAtCell = (props: ICreatedAtCellProps) => {
    const dateTimeService = useService(DateTimeService);

    return (
        <Cell>
            {dateTimeService.toLocaleString(props.insertedAt.toLocal(), LocaleFormats.DateTime)}
        </Cell>
    );
};
